import React, { useEffect, useState } from "react";
import { getDisplayName } from "data/constants";
import { useSelector } from "react-redux";
import * as s from "data/reducers/selectors";
import { usePrevious } from "hooks";
import { ServerEventItemType, ServerEventActionType } from "data/types";

const RedirectDeletedFolderItemUriToParent = (
    WrappedComponent: ComponentType<any>
) => {
    const HOC = ({ refreshId = 0, refreshEvent, itemUri, ...props }: Props) => {
        const [activeItemUri, setActiveItemUri] = useState(itemUri);
        const prevRefreshId = usePrevious(refreshEvent?.id);

        const treeTotalCount: number = useSelector(s.treeTotalCountSelector);

        useEffect(() => {
            if (
                refreshEvent?.id !== prevRefreshId &&
                // if the refresh event is a delete action on a folder...
                refreshEvent?.item === ServerEventItemType.folder &&
                refreshEvent?.action === ServerEventActionType.delete &&
                refreshEvent?.data?.parentItemUri &&
                // ... and the tree only has one item (so we deleted the only item in the tree) ...
                treeTotalCount === 1
            ) {
                // ... then set the active item to the parent item of the deleted item
                setActiveItemUri(refreshEvent.data.parentItemUri);
            }
        }, [refreshId, refreshEvent, treeTotalCount, itemUri, prevRefreshId]);

        return (
            <WrappedComponent
                {...props}
                refreshId={refreshId}
                itemUri={itemUri}
                activeItemUri={activeItemUri}
                setActiveItemUri={setActiveItemUri}
            />
        );
    };
    HOC.displayName = `RedirectDeletedFolderItemUriToParent(${getDisplayName(
        WrappedComponent
    )})`;
    return HOC;
};

export default RedirectDeletedFolderItemUriToParent;
